import { type FC } from 'react';
import { ModalComponent } from '~/_shared/components/modal/modal.component';
import { useTranslation } from '~/_shared/utils/hooks';
import { MapTemplatesComponent } from '~/map/mapTemplatesModal/mapTemplates.component';
import { type MapTemplates } from '~/map/mapTemplatesModal/mapTemplates.helpers';
import {
  MAP_TEMPLATES_MODAL_WIDTH, mapTemplatesModalContentStyle,
} from '~/map/mapTemplatesModal/mapTemplatesModal.container';
import { type ModalProps } from '~/modal/modalType.enum';
import { useCreateNewMap } from '../prepareDataModal/useCreateNewMap';

type WelcomeModalProps = ModalProps;

export const WelcomeModalComponent: FC<WelcomeModalProps> = props => {
  const [t] = useTranslation();
  const { onCreateNewMap } = useCreateNewMap();

  const handleTemplateSelected = (template: MapTemplates) => {
    onCreateNewMap({ preselectedTemplate: template });
    props.onClose();
  };

  return (
    <ModalComponent
      caption={t('welcomeModal.caption')}
      contentStyle={mapTemplatesModalContentStyle}
      isOpen={props.isOpen}
      onClose={props.onClose}
      maxWidth={MAP_TEMPLATES_MODAL_WIDTH}
    >
      {t('welcomeModal.description')}
      <MapTemplatesComponent
        onTemplateSelected={handleTemplateSelected}
      />
    </ModalComponent>
  );
};
